import React from 'react';
import styles from './container.module.scss'
/**
 * 
 */
export default function BaseContainer(props) {
  const { children, className, hideRight=false } = props

  return (
    <div className={`grid grid-cols-12 gap-4 container ${styles.container} ${className || ''}`}>
      <div className={`lg:col-start-2 col-span-12 ${hideRight?'lg:col-span-11':'lg:col-span-10'}`}>
        {children}
      </div>
    </div>
  );
}
